(function () {
    "use strict";

    angular
        .module("app")
        .directive("retailChannelSearchHelp", ["SearchFactory", retailChannelSearchHelp]);

    function retailChannelSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.retailChannelKey = "";
                        scope.retailChannelName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.retailChannelName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.retailChannelSearch(scope.sapBrandId, function (retailChannel) {
                        scope.retailChannelKey = retailChannel ? retailChannel.RetailChannelKey : "";
                        scope.retailChannelName = retailChannel ? retailChannel.RetailChannelName : "";
                        scope.displayValue = scope.retailChannelName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("retailChannelName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.retailChannelName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { retailChannelKey: "=", retailChannelName: "=", readOnly: "=", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

